<div class="flex flex-col gap-4">
  <div [formGroup]="filtro" class="flex flex-row justify-between items-center w-full">
    @for (chave of [limparMotorista]; track chave) {
    <driver-autocomplete class="w-3/12 px-2" (driverChange)="onMotoristaChange($event)" />
    }
    <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="tipoImpedimentoId">
        <mat-option [value]="null">Todos</mat-option>
        @for (tipo of tiposImpedimento; track tipo.id) {
        <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
      <mat-label>Data início</mat-label>
      <input matInput [matDatepicker]="dataInicio" formControlName="dataInicio" />
      <mat-datepicker-toggle matIconSuffix [for]="dataInicio"></mat-datepicker-toggle>
      <mat-datepicker #dataInicio></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
      <mat-label>Data fim</mat-label>
      <input matInput [matDatepicker]="dataFim" formControlName="dataFim" />
      <mat-datepicker-toggle matIconSuffix [for]="dataFim"></mat-datepicker-toggle>
      <mat-datepicker #dataFim></mat-datepicker>
    </mat-form-field>
    <div class="flex justify-center items-center mb-4 gap-2">
      <button class="btn-icon" (click)="limparFiltro()" [matTooltip]="'Limpar Pesquisar'">
        <mat-icon>replay</mat-icon>
      </button>
      <button class="btn-icon" (click)="buscar()" [matTooltip]="'Pesquisa'">
        <mat-icon>search</mat-icon>
      </button>
    </div>
  </div>

  <div class="flex justify-between items-center">
    <div class="text-sm text-gray-600">{{ periodoAplicado }}</div>
    <button mat-flat-button class="btn-tg" (click)="novoImpedimento()">
      <mat-icon>add</mat-icon>
      Novo impedimento
    </button>
  </div>

  @if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else if (impedimentos.length === 0) {
  <div class="text-center text-gray-500 py-4">Nenhum impedimento encontrado.</div>
  } @else {
  <div class="tab-overflow">
    <table mat-table [dataSource]="impedimentos" class="mat-elevation-z8 w-full">
      <ng-container matColumnDef="motorista">
        <th mat-header-cell *matHeaderCellDef>Motorista</th>
        <td mat-cell *matCellDef="let item">{{ item.motoristaNome }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let item">{{ item.tipo }}</td>
      </ng-container>

      <ng-container matColumnDef="periodo">
        <th mat-header-cell *matHeaderCellDef>Período</th>
        <td mat-cell *matCellDef="let item">{{ item.resumo }}</td>
      </ng-container>

      <ng-container matColumnDef="observacao">
        <th mat-header-cell *matHeaderCellDef>Observação</th>
        <td mat-cell *matCellDef="let item">{{ item.observacao || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let item" class="text-center">
          <mat-icon class="btn-icon-outline" fontIcon="delete" matTooltip="Remover" (click)="remover(item)"></mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  }
</div>
